import gql from 'graphql-tag';
// import {compact} from 'lodash';

const recommendedListingsQuery = gql`
    query($listingIds: [String]!, $size: Int = 8) {
        recommendedListingResponse(listingTriads: $listingIds, size: $size) {
            recommendedListings {
                listing {
                    # averageRating
                    # reviewCount
                    listingId
                    # detailPageUrl
                    # bedrooms
                    # sleeps
                    images {
                        uri
                    }
                    # issues with priceSummary on local env
                    # priceSummary(currency: "USD") {
                    #     amount
                    #     formattedAmount
                    #     roundedFormattedAmount
                    # }
                }
            }
        }
    }
`;

const prepareResponse = (response) => {
    const listings =
        // TODO: update with real response fields
        response.recommendedListingResponse.recommendedListings;
    // return listings.filter(({listing}) => {
    //     const {images, bedrooms, sleeps, averageRating, reviewCount, priceSummary = {}} = listing;
    //     const {formattedAmount, roundedFormattedAmount} = priceSummary;
    //     const imageUrl = images && !!images.length && images[0].uri;
    //     const propertyDetails = bedrooms && sleeps;
    //     const reviews = averageRating && reviewCount;
    //     const priceDetails = formattedAmount && roundedFormattedAmount;

    //     // carousel card display conditions:
    //     // 1. image
    //     // 2. two of three content items:
    //     //    a) bedrooms and sleeps count
    //     //    b) avarage rating and reviews count
    //     //    c) pricing info
    //     return imageUrl && compact([propertyDetails, reviews, priceDetails]).length > 1;
    // });
    return listings;
};

export {recommendedListingsQuery, prepareResponse};
